import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import Dropzone from 'react-dropzone';

import InputField from '../../../components/inputs/inputField.js';
import SelectField from '../../../components/inputs/selectField.js';
import TimeField from '../../../components/inputs/timeField.js';
import FilesUploaderModal from '../../../components/files/filesUploaderModal.js';
import FileChooserPreview from '../../../components/inputs/fileChooserPreview.js';
import ToggleField from '../../../components/inputs/toggleField.js';

let dropzoneRef;

const statusOptions = [
	{ label: 'Imported', value: 'imported' },
	{ label: 'Invited', value: 'invited' },
	{ label: 'Registered', value: 'registered' },
	{ label: 'Not attending', value: 'not attending' },
	{ label: 'Checked in', value: 'checked in' },
	{ label: 'Incomplete', value: 'incomplete' },
	{ label: 'Entered through SSO', value: 'entered through SSO' },
	{ label: 'Removed', value: 'removed' },
	{ label: 'Did not attend', value: 'did not attend' },
	{ label: 'Cancelled', value: 'cancelled' }
];

const getMeta = (url, cb) => {
	const img = new Image();
	img.onload = () => cb(null, img);
	img.onerror = (err) => cb(err);
	img.src = url;
};

class EventAttendeeIntegrations extends Component {
	constructor(props) {
		super(props);
		this.state = {
			files: [],
			accepted: [],
			rejected: [],
			genExpanded: true
		};
	}
	render() {
		const { editedAttendee } = this.props;
		return (
			<div className='sectionBlock'>
				{editedAttendee.integrationData.medpro && <div>

					<h2 className="blockHeader">MedPro</h2>

					<InputField
						label="MedPro ID"
						value={editedAttendee.integrationData.medpro.medProId}
						disabled={true}
						type="text"
						inputIcon={<i className="las la-lock" />}
					/>

					<InputField
						label="NPI Number"
						value={editedAttendee.integrationData.medpro.NPINumber}
						disabled={true}
						type="text"
						inputIcon={<i className="las la-lock" />}
					/>

					<InputField
						label="State License Number"
						value={editedAttendee.integrationData.medpro.stateLicenseNumber}
						disabled={true}
						type="text"
						inputIcon={<i className="las la-lock" />}
					/>
					<InputField
						label="State License State"
						value={editedAttendee.integrationData.medpro.licenseState}
						disabled={true}
						type="text"
						inputIcon={<i className="las la-lock" />}
					/>
				</div>}
				{editedAttendee.integrations && editedAttendee.integrations.salesforce && <div >
					<h2 className="blockHeader">Salesforce</h2>

					<ToggleField label={`Is Lead`} disabled={true} checked={editedAttendee.integrations.salesforce.leadId && editedAttendee.integrations.salesforce.leadId != ''} icons={false} />
					<ToggleField label="Is Contact" disabled={true} checked={editedAttendee.integrations.salesforce.contactId && editedAttendee.integrations.salesforce.contactId != ''} icons={false} />
					<InputField
						label="Account Name"
						value={editedAttendee.integrations.salesforce.accountName}
						disabled={true}
						type="text"
						inputIcon={<i className="las la-lock" />}
					/>
				</div>}
			</div>
		);
	}
}

export default EventAttendeeIntegrations;
